var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"id":("form-delete-" + _vm.formIdentifier)},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('b-row',[_c('b-col',[_c('b-button',{attrs:{"block":"","type":"submit","variant":"danger"}},[_vm._v(_vm._s(_vm.$t('actions.delete')))])],1)],1)],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42d26057","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@triotech/vue-core/src/components/ajax/AjaxDelete.vue
// module id = 930
// module chunks = 1